import React from 'react';
import { ToastContent } from 'react-toastify';
import ToastContext from './ToastContext';

interface WithToastProps {
  toastError: () => void;
  toastSuccess: (content: ToastContent) => void;
}

function withToast<T extends WithToastProps = WithToastProps>(
  WrappedComponent: React.ComponentType<T>
) {
  const displayName = WrappedComponent.displayName || WrappedComponent.name || 'Component';

  const ComponentWithToast = (props: Omit<T, keyof WithToastProps>) => {
    return (
      <ToastContext.Consumer>
        {(contexts) => <WrappedComponent {...contexts} {...(props as T)} />}
      </ToastContext.Consumer>
    );
  };

  ComponentWithToast.displayName = `withToast(${displayName})`;

  return ComponentWithToast;
}

export default withToast;
